export default "__VITE_ASSET__Daupanxb__"